import React, { useEffect, useState } from "react";
import ConractUsBanner from "./components/conractUsBanner";
import ContactInfoBanner from "./components/contactInfoBanner";
import OurBranches from "./components/ourBranches";
import MetaTagsSEO from "../../utils/metaTagsFunction";
import DB from "../../utils/db.json";
import Loader from "../../components/loader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { fetchOfficeDetails } from "../../redux/homeSlice";
import { office } from "../../interface/officedetails.interface";
function ContactUsPage() {
  const dispatch = useDispatch<AppDispatch>();
  const officeDetails: { office: office[], headoffice: office[] } = useSelector(
    (state: any) => state.home.officeDetails || { office: [], headoffice: [] }
  );
  const isLoading = useSelector(
    (state: any) => state.home.loadingOfficeDetails
  );
  useEffect(() => {
    dispatch(fetchOfficeDetails());
  }, [dispatch]);

  return (
    <>
      <Loader isLoading={isLoading} />
      <MetaTagsSEO metaTags={DB.contactUsMetaTags} title="Contact Us - JBGlass" />
      <ConractUsBanner />
      {!isLoading && officeDetails.headoffice.length > 0 && (<ContactInfoBanner officeDetails={officeDetails.headoffice[0]} />)}
      {!isLoading && officeDetails.office.length > 0 && (<OurBranches officeDetails={officeDetails.office} />)}
    </>
  );
}
export default ContactUsPage;
